import { render, staticRenderFns } from "./ms-select-prescrip.vue?vue&type=template&id=290bc4b6&scoped=true"
import script from "./ms-select-prescrip.vue?vue&type=script&lang=js"
export * from "./ms-select-prescrip.vue?vue&type=script&lang=js"
import style0 from "./ms-select-prescrip.vue?vue&type=style&index=0&id=290bc4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290bc4b6",
  null
  
)

export default component.exports